var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.trans.get('userEdit.wallet_description')))]),_c('a',{attrs:{"target":"_blank","href":_vm.walletLink}},[_vm._v(_vm._s(_vm.trans.get('userEdit.wallet_link')))])])}
var staticRenderFns = []

export { render, staticRenderFns }